import React from "react";
import { useNotifications } from "~/contexts/useNotifications";
import NotificationContainer from "~/pages/CharacterSheet/widgets/RollNotification/NotificationContainer";

/**
 * NotificationOverlay Component
 *
 * Top-level component that renders the NotificationContainer.
 * Should be placed in App.tsx to make notifications available globally.
 */
const NotificationOverlay: React.FC = () => {
  const { notifications, dismissNotification } = useNotifications();

  return (
    <NotificationContainer
      notifications={notifications}
      onDismiss={dismissNotification}
    />
  );
};

export default NotificationOverlay;
